import { withNavigation }      from 'components/App/withNavigation';
import { WithNavigationProps } from 'components/App/withNavigation';
import React                   from 'react';
import { privateLayoutStore }  from 'stores/index';
import StandImportSteps        from '../components/StandImportSteps';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';

class StandImport extends React.Component<WithNavigationProps> {
  public async componentDidMount() {
    try {
      await privateLayoutStore.setCurrentShowId(this.props.params.showId);
    } catch (error: any) {
      if (error.name === 'show_not_found') {
        this.props.navigate('/404');
      }

      if (error.name === 'get_show_unauthorized') {
        this.props.navigate('/erreur');
      }

      return;
    }
  }

  public render() {
    return (
      <div
        style={{
          background: '#fff',
          display: 'flex',
          flexDirection: 'column',
          marginTop: 16,
          minHeight: 360,
          padding: 24,
        }}
      >
        <h2>
          <FormattedMessageWrapper id="Importer des stands" />
        </h2>
        <StandImportSteps />
      </div>
    );
  }
}

const WrappedStandImport = withNavigation(StandImport);

export default WrappedStandImport;
